<div class="hero-wrap">
  <section class="hero">
    <div class="hero__slides">
      @for (slide of heroSlides; track slide.title; let i = $index) {
        <div
          class="hero__slide"
          [class.hero__slide--active]="i === activeSlide()"
          [style.background-image]="'linear-gradient(180deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.05) 45%, rgba(255,255,255,0.25) 100%), url(' + slide.background + ')'"
        ></div>
      }
    </div>

    <button type="button" class="hero__arrow hero__arrow--prev" aria-label="Previous slide" (click)="previousSlide()">‹</button>
    <button type="button" class="hero__arrow hero__arrow--next" aria-label="Next slide" (click)="nextSlide()">›</button>

    <div class="hero__content">
      <span class="hero__eyebrow">{{ heroSlides[activeSlide()].eyebrow | translate }}</span>
      <h1 class="hero__title">{{ heroSlides[activeSlide()].title | translate }}</h1>
      <p class="hero__subtitle">
        @for (line of (heroSlides[activeSlide()].subtitle | translate).split('\n'); track line; let last = $last) {
          {{ line }}@if (!last) {<br />}
        }
      </p>
    </div>

    <div class="hero__dots">
      @for (slide of heroSlides; track slide.title; let i = $index) {
        <button
          type="button"
          class="hero__dot"
          [class.hero__dot--active]="i === activeSlide()"
          [attr.aria-label]="'Go to slide ' + (i + 1)"
          (click)="goToSlide(i)"
        ></button>
      }
    </div>
  </section>

  <div class="hero__prayer-card">
    <span class="hero__prayer-label">{{ 'common.next_prayer' | translate }}</span>
    <div class="hero__prayer-main-row">
      <span class="hero__prayer-time">{{ nextPrayer.time }}</span>
      <div class="hero__prayer-name-col">
        <span class="hero__prayer-name">{{ nextPrayer.name }}</span>
        <span class="hero__prayer-sun" aria-hidden="true">☀️</span>
      </div>
    </div>
    <span class="hero__prayer-countdown">{{ nextPrayer.countdown }} <small>{{ 'common.to_go' | translate }}</small></span>
    <a [routerLink]="routes.PRAYER_TIMES" class="hero__prayer-link">{{ 'common.view_all_prayer_times' | translate }}</a>
  </div>

  <div class="hero__date-card">
    <span class="hero__date-label">{{ 'common.today' | translate }}</span>
    <span class="hero__date-gregorian">{{ islamicDate.gregorian }}</span>
    <span class="hero__date-weekday">{{ islamicDate.weekday }}</span>
    <span class="hero__date-hijri">{{ islamicDate.day }} {{ islamicDate.hijriMonthYear }}</span>
  </div>
</div>

<section class="feature-grid">
  @for (feature of features; track feature.path) {
    <app-nav-tile [icon]="feature.icon" [label]="feature.title | translate" [subtitle]="feature.subtitle | translate" [path]="feature.path"></app-nav-tile>
  }
</section>

<section class="dashboard-grid">
  <app-card [title]="'common.continue_reading' | translate" class="continue-reading">
    <div class="continue-reading__body">
      <span class="continue-reading__icon" aria-hidden="true">📖</span>
      <div class="continue-reading__info">
        <span class="continue-reading__surah">{{ continueReading.surah }}</span>
        <span class="continue-reading__verse">{{ continueReading.verse }}</span>
        <div class="continue-reading__progress-bar">
          <div class="continue-reading__progress-fill" [style.width.%]="continueReading.progress"></div>
        </div>
        <span class="continue-reading__progress-label">{{ continueReading.progress }}%</span>
      </div>
    </div>
    <button type="button" class="btn btn--primary">{{ 'common.continue_reading' | translate }}</button>
  </app-card>

  <app-card [title]="'common.daily_amaal_progress' | translate" class="amaal-progress">
    <div class="amaal-progress__body">
      <app-ring-progress [percent]="amaalProgress"></app-ring-progress>
      <ul class="amaal-progress__breakdown">
        @for (item of amaalBreakdown; track item.label) {
          <li>
            <span>{{ item.label | translate }}</span>
            <span>{{ item.value }}</span>
          </li>
        }
      </ul>
    </div>
    <a [routerLink]="routes.AMAAL_PLANNER" class="card__link">{{ 'common.view_details' | translate }}</a>
  </app-card>

  <app-quote-card [arabic]="quote.arabic" [translation]="quote.translation" [reference]="quote.reference"></app-quote-card>
</section>

<section class="cta-banner">
  <div class="cta-banner__illustration" aria-hidden="true">🏮</div>
  <div class="cta-banner__content">
    <h2>{{ 'common.make_every_day_count' | translate }}</h2>
    <p>{{ 'common.small_deeds' | translate }}</p>
    <button type="button" class="btn btn--primary" [routerLink]="routes.AMAAL_PLANNER">{{ 'common.plan_your_amaal' | translate }}</button>
  </div>
  <div class="cta-banner__values">
    @for (value of valueProps; track value.title) {
      <div class="cta-banner__value">
        <span class="cta-banner__value-icon" aria-hidden="true">{{ value.icon }}</span>
        <div>
          <strong>{{ value.title | translate }}</strong>
          <span>{{ value.subtitle | translate }}</span>
        </div>
      </div>
    }
  </div>
</section>
